import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasSectionModule } from '../gas-section/gas-section.module';
import { GasAccordionComponent } from './gas-accordion.component';
import { GasAccordionSectionDirective } from './gas-accordion-section.directive';

const COMPONENTS = [
  GasAccordionComponent,
];

const DIRECTIVES = [
  GasAccordionSectionDirective,
];

@NgModule({
  declarations: [
    COMPONENTS,
    DIRECTIVES,
  ],
  exports: [
    COMPONENTS,
    GasSectionModule,
    DIRECTIVES,
  ],
  imports: [
    CommonModule,
    GasSectionModule,
  ],
})
export class GasAccordionModule { }
